module.exports = __webpack_public_path__ + "img/ico_karmitt2.8d5f74cc.svg";